<template>
  <div class="projects">
    <h2>Réalisations</h2>
    <ul>
      <li v-for="item in items" :key="item.type">
        <button v-on:click="setType(item.type)" v-bind:class="{ active: item.isActive }">{{ item.type }}</button>
      </li>
    </ul>
    <div class="container-img" v-bind:class="{ fullheight: isResized }">
      <button
        v-for="project in selectedProject"
        :key="project.name"
        class="project-btn"
        @click="project.isVisible = !project.isVisible"
      >
        <img v-bind:src="require('../assets/icons-project/' + project.img)" class="project-icon" />
      </button>
    </div>
    <ProjectDetails />

    <div class="mobile">
      <button
        v-on:click="ResizeContainer()"
        v-if="!isResized && this.selectedProject.length > 6"
        class="see-all-mobile"
      >
        Voir tous les projets
      </button>
      <button v-on:click="ResizeContainer()" v-else-if="this.selectedProject.length > 6" class="see-all-mobile">
        Cacher les projets
      </button>
    </div>
    <div class="tablet">
      <button
        v-on:click="ResizeContainer()"
        v-if="!isResized && this.selectedProject.length > 10"
        class="see-all-tablet"
      >
        Voir tous les projets
      </button>
      <button v-on:click="ResizeContainer()" v-else-if="this.selectedProject.length > 10" class="see-all-tablet">
        Cacher les projets
      </button>
    </div>
  </div>
</template>

<script>
import projects from '../json/projects.json';
import ProjectDetails from '@/components/ProjectDetails';

export default {
  name: 'Projects',
  data: function() {
    return {
      items: [
        { type: 'Tous', isActive: true },
        { type: 'Applications', isActive: false },
        { type: 'Jeux', isActive: false },
        { type: 'Graphisme', isActive: false }
      ],
      MyProjects: projects,
      selectedProject: projects,
      isResized: false
    };
  },

  components: {
    ProjectDetails
  },

  methods: {
    ResizeContainer() {
      this.isResized = !this.isResized;
    },
    getCurrentType() {
      return this.items.find(item => item.isActive === true);
    },

    getProjects(type) {
      if (type === 'Tous') {
        return this.MyProjects;
      }
      return this.MyProjects.filter(project => project.type == type);
    },

    getType(type) {
      return this.items.find(item => item.type == type);
    },

    setType(type) {
      if (type != this.getCurrentType()) {
        let currentItem = this.getCurrentType();
        currentItem.isActive = false;
        let newItem = this.getType(type);
        newItem.isActive = true;
        this.selectedProject = this.getProjects(newItem.type);
        this.isResized = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.projects {
  margin-top: 40px;

  ul {
    display: flex;
    justify-content: center;
    flex-flow: row wrap;
  }
  button {
    font-size: 0.8em;
    cursor: pointer;
    border: none;
    background-color: #fff;
  }

  button.active {
    color: var(--orange);
    font-weight: bold;
  }

  .fullheight {
    height: auto !important;
  }

  .container-img {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    margin: 50px 0;
    height: 200px;
    overflow: hidden;

    .project-btn {
      padding: 0;
      margin: 0;
      position: relative;
    }

    .project-icon {
      width: 100px;
      height: 100px;
    }
  }

  .see-all-mobile {
    border: 1px solid var(--black);
    border-radius: 3px;
    font-size: 12px;
    padding: 10px;
  }

  .see-all-tablet {
    display: none;
  }
}

@media only screen and (min-width: 720px) {
  .projects {
    .container-img {
      height: 300px;
      .project-icon {
        width: 150px;
        height: 150px;
      }
    }
    button {
      font-size: 1.2em;
    }

    .see-all-mobile {
      display: none;
    }

    .see-all-tablet {
      border: 1px solid var(--black);
      margin: auto;
      border-radius: 3px;
      font-size: 12px;
      padding: 10px;
      display: block;
    }
  }
}

@media screen and (min-width: 1024px) {
  .projects {
    margin-top: 80px;
    padding-bottom: 70px;
    .see-all-tablet {
      display: none;
    }
  }
}
</style>
